<template>
  <div class="step">
    <p class="title">
      <span class="icon-need">*</span>报告数据时间范围
    </p>
    <div class="recent-date">
      <span @click="getRecentDate(1)" :class="this.indexDate == 1 ? 'active':''">最近30天</span>
      <span @click="getRecentDate(2)" :class="this.indexDate == 2 ? 'active':''">最近90天</span>
      <span @click="getRecentDate(3)" :class="this.indexDate == 3 ? 'active':''">最近一年</span>
      <span @click="getRecentDate(4)" :class="this.indexDate == 4 ? 'active':''">服务开始至今</span>
    </div>
    <el-date-picker
      v-model="reportDate"
      value-format="yyyy-MM-dd"
      size="small"
      type="daterange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      range-separator="~"
      :clearable="false"
    ></el-date-picker>
    <el-button style="margin:10px 0;" size="small" @click="checkCookie">校验投诉账号Cookie信息</el-button>
    <br />
    <el-button
      type="primary"
      :loading="loadingCookie"
      plain
      size="small"
      v-if="loadingCookie"
    >{{'Cookie信息校验中，请稍后...'}}</el-button>
    <el-alert
      :title="cookieMsg"
      type="error"
      size="small"
      show-icon
      v-if="cookieUpdate"
      @close="cookieUpdate=false"
    ></el-alert>
    <div
      class="countItem"
      v-for="(countItem,index) in countList"
      :key="index"
      v-show="countItem.updateList && countItem.updateList.length>0"
    >
      <p class="title">{{countItem.platname}}</p>
      <p class="list" v-for="(item,i) in countItem.updateList" :key="i">
        <span>{{item.title}}:{{item.user_name}}</span>
        <span class="cookie" @click="updateCookie(countItem.platform,item,index)">更新cookie</span>
      </p>
    </div>
    <div class="footBtn">
      <el-button size="small" class="confirm" @click="stepNext(1)">下一步</el-button>
      <el-button size="small" class="cancel" @click="stepNext(0)">跳过cookie更新，下一步</el-button>
      <el-button size="small" class="cancel" @click="$router.push({path: '/ServiceReport' })">返回</el-button>
    </div>
    <p class="info">说明：投诉账号Cookie未更新，报表将使用历史存储的数据生成，可能会导致报表信息不精准。</p>
    <!-- 更新cookie弹框 -->
    <el-dialog
      title="更新Cookie"
      :visible.sync="updateCookieDialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form :model="cookieForm" :rules="cookieFormRules" ref="cookieForm" label-width="80px">
        <el-form-item label="名称" prop="title">
          <el-input v-model.trim="cookieForm.title"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="user_name">
          <el-input v-model.trim="cookieForm.user_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model.trim="cookieForm.password"></el-input>
        </el-form-item>
        <el-form-item label="Cookie" prop="cookie">
          <el-input v-model.trim="cookieForm.cookie"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" class="confirm" @click="confirmCookie">确 定</el-button>
        <el-button size="small" class="cancel" @click="updateCookieDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getRecentOneMonth,
  getSinceThreeMonth,
  getRecentOneYear,
  getTodayTime
} from "@/libs/date.js";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      loadingCookie: false,
      isCheckCookie: false,
      cookieMsg: "",
      cookieUpdate: false,

      reportDate: [],
      indexDate: 0,
      countList: [
        { platname: "阿里", platform: "AL", platParam: "taobao"},
        { platname: "京东", platform: "JD", platParam: "jd" },
        { platname: "苏宁", platform: "SN", platParam: "suning"},
        { platname: "拼多多", platform: "PDD", platParam: "pdd"}
      ],
      updateIndex: 0,
      platform: "",
      updateCookieDialog: false,
      cookieForm: {},
      cookieFormRules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        user_name: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        cookie: [{ required: true, message: "请输入Cookie", trigger: "blur" }]
      },
      complaintsaccount: [],
      checkCookCooks: [],
      isUpdateCookie: false,
      reCheck: false,
      canSkip: false,
      changeCookie: []
    };
  },
  created() {
    this.reqGetbmcwx();
    this.loadFirst();
  },
  computed: {
    ...mapState({
      userInfo: state => state.serviceReport.userinfo
    })
  },
  methods: {
    ...mapActions(["reqGetbmcwx"]),
    ...mapMutations(["saveCheckCookCooks"]),
    getRecentDate(i) {
      this.indexDate = i;
      let res = [];
      switch (i) {
        case 1:
          res = getRecentOneMonth();
          break;
        case 2:
          res = getSinceThreeMonth();
          break;
        case 3:
          res = getRecentOneYear();
          break;
        default:
          let serviceStart = this.$options.filters["fullTime"](
            this.userInfo.createtime
          );
          let serviceEnd = this.$options.filters["fullTime"](
            new Date().getTime()
          );
          res = [serviceStart, serviceEnd]; //服务开始至今
      }
      this.reportDate = [res[0].substr(0, 10), res[1].substr(0, 10)];
    },
    load(platform) {
      let params = { platform: platform };
      return new Promise((r, j) => {
        fetchGet("hcm/complaiont/getListByBmcid", params)
          .then(res => {
            r(res.data);
          })
          .catch(() => {
            j([]);
          });
      });
    },
    // 获取需要验证的cookie信息
    getCookieParam(countList, platform) {
      let paramsItem = {};
      let params = [];
      for (let item of countList) {
        paramsItem = {
          entityPlatform: platform,
          password: item.password,
          title: item.title,
          id: item.id,
          iprName: "",
          entityType: "item",
          gmtCreateStart: this.reportDate[0],
          gmtCreateEnd: this.reportDate[1],
          cookie: item.cookie,
          user_name: item.username,
          page: "",
          pageNum: 0,
          getAllResult: "true"
        };
        params.push(paramsItem);
      }
      return params;
    },
    async loadFirst() {
      this.allUserName = [];
      this.cookieInfo = [];
      for (let i = 0; i < this.countList.length; i++) {
        let reqData = await this.load(this.countList[i].platform);
        this.$set(this.countList[i], "listData", reqData.slice(0, 1));
        let cookieList = this.getCookieParam(
          this.countList[i].listData,
          this.countList[i].platParam
        );
        for (let cookieItem of cookieList) {
          this.cookieInfo.push(cookieItem);
          this.allUserName.push(cookieItem.user_name);
        }
      }
      console.log(this.countList);
      console.log(this.allUserName);
    },
    // 验证cookie
    checkCookie() {
      if (!this.reportDate.length > 0) {
        this.$message.info("请先选择报告数据时间范围");
        return false;
      }
      let old = this.cookieInfo;
      if (this.changeCookie.length > 0) {
        old.forEach((item, index) => {
          this.changeCookie.forEach(items => {
            if (item.id == items.id) {
              old[index].cookie = items.cookie;
              old[index].password = items.password;
              old[index].title = items.title;
              old[index].username = items.username;
            }
          });
        });
      }
      console.log(this.cookieInfo);
      if (this.cookieInfo.length === 0) {
        this.cookieMsg = `当前品牌方未绑定投诉账号，可跳过cookie更新，下一步`;
        this.cookieUpdate = true;
        this.canSkip = true;
        return false;
      }
      let param = {
        param: JSON.stringify(this.cookieInfo)
      };
      this.reqCheckCookie(param);
    },
    reqCheckCookie(param) {
      this.loadingCookie = true;
      this.isCheckCookie = true;
      this.complaintsaccount = [];
      fetchPost("hcm/hcmChannelServiceReport/validationCookie", param).then(
        res => {
          if (res.status === "10000") {
            if (res.data == "服务器异常" || !res.data) {
              this.cookieMsg = `爬虫或服务器异常，请联系技术人员处理，或跳过cookie更新。`;
              this.cookieUpdate = true;
            } else {
              let data = JSON.parse(res.data);
              this.complaintsaccount = data; //验证完成后的cookie
              let isSuccess = data.filter(item => {
                return item.success === "True";
              });
              if (isSuccess.length === data.length) {
                this.$message.success("投诉账号cookie验证通过");
              }
              this.getUpdateList(data);
            }
          } else {
            this.cookieMsg = res.message;
            this.cookieUpdate = true;
          }
          this.loadingCookie = false;
          this.reCheck = false;
        }
      );
      console.log(this.cookieUpdate);
      this.$forceUpdate();
    },
    getUpdateList(data) {
      this.countList.forEach(item=>{
        item.updateList=[]
      })
      data.forEach((item)=>{
        this.countList.forEach((items,indexs)=>{
          if(item.platform===items.platParam&&item.success === "False"){
            this.countList[indexs].updateList.push(item)
          }
        })
      })
      console.log(this.countList)
    },
    // 更新cookie
    updateCookie(platform, item, i) {
      this.platform = platform;
      this.cookieForm = { ...item };
      this.updateCookieDialog = true;
      this.updateIndex = i;
    },
    confirmCookie() {
      this.$refs["cookieForm"].validate(valid => {
        if (valid) {
          const { title, user_name, cookie, password, id } = this.cookieForm;
          let data = {
            title,
            cookie,
            password,
            id,
            platform: this.platform,
            username: user_name
          };
          fetchPost("hcm/complaiont/save", data).then(res => {
            if (res.status === "10902") {
              this.$message.error(res.message);
            }
            if (res.status === "10000") {
              this.$message.success("更新成功");
              this.updateCookieDialog = false;
              this.reCheck = true;
              this.changeCookie.push(res.data);
            }
          });
        }
      });
    },
    getSaveValidParams(isNeedValid) {
      this.checkCookCooks = [];
      if (this.complaintsaccount.length > 0) {
        let successItem = this.complaintsaccount.filter(item => {
          return item.success === "True";
        });

        if (successItem.length > 0) {
          successItem.map(data => {
            let obj = {
              entityPlatform: data.platform,
              iprName: "",
              entityType: "item",
              gmtCreateStart: this.reportDate[0],
              gmtCreateEnd: this.reportDate[1],
              cookie: data.cookie,
              user_name: data.user_name,
              getAllResult: "true",
              statusid:Date.now()
            };
            this.checkCookCooks.push(obj);
          });
        }
        if (
          successItem.length != this.complaintsaccount.length &&
          isNeedValid
        ) {
          //有项未通过
          return false;
        } else {
          return true;
        }
      }
    },
    async stepNext(updateCookie) {
      console.log(updateCookie)
      const isNeedValid = updateCookie;
      if (!this.reportDate.length > 0) {
        this.$message.info("请先选择报告数据时间范围");
        return false;
      }
        let result = this.getSaveValidParams(isNeedValid);
          this.saveCheckCookCooks(this.checkCookCooks);
      if (isNeedValid !== 0) {
        if (isNeedValid && !this.isCheckCookie && !this.canSkip) {
          this.$message.info("请先校验投诉账号Cookie信息并更新");
          return false;
        }
        if (this.complaintsaccount.length === 0 && !this.canSkip) {
          this.$message.info("请先验证cookie信息");
          return false;
        }
        if (this.reCheck) {
          this.$message.info("请重新验证cookie信息");
          return false;
        }
        if (!result && !this.canSkip) {
          this.$message.info("有账号cookie信息未更新");
          return false;
        }
      
      }
      this.$store.commit("changeStep", {
        stepText: "第二步",
        step: 1
      });
      let query = {
        begintime: this.reportDate[0],
        endtime: this.reportDate[1],
        bmcid: this.userInfo.bid,
        complaintsaccount: String(this.allUserName)
      };
      this.$store.commit("createQuery", query);
    }
  }
};
</script>
<style lang="scss">
$highColor: #108cee;
.step {
  width: 27%;
  min-width: 445px;
  margin: 40px auto 0;
  .icon-need {
    color: red;
    padding-right: 10px;
    vertical-align: middle;
  }
  .recent-date {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0 0 6px 0;
    color: #999;
    span {
      cursor: pointer;
      &.active {
        color: #108cee;
      }
    }
  }
  .el-range-editor--small.el-input__inner {
    width: 100%;
  }
  p.title {
    font-size: 15px;
    font-weight: 600;
  }
  p.list {
    margin: 0;
    display: flex;
    justify-content: space-between;
    .cookie {
      color: $highColor;
      cursor: pointer;
    }
  }
  .footBtn {
    display: flex;
    justify-content: space-between;
  }
  p.info {
    color: #999999;
  }
}
</style>